export type IndianStateOption = { code: string; name: string };

/** Zoho Books Indian state/UT codes — keep in sync with backend ZohoGeoResolver.php */
export const INDIAN_STATES: IndianStateOption[] = [
  { code: "AN", name: "Andaman and Nicobar Islands" },
  { code: "AD", name: "Andhra Pradesh" },
  { code: "AR", name: "Arunachal Pradesh" },
  { code: "AS", name: "Assam" },
  { code: "BR", name: "Bihar" },
  { code: "CH", name: "Chandigarh" },
  { code: "CG", name: "Chhattisgarh" },
  { code: "DN", name: "Dadra and Nagar Haveli and Daman and Diu" },
  { code: "DD", name: "Daman and Diu" },
  { code: "DL", name: "Delhi" },
  { code: "GA", name: "Goa" },
  { code: "GJ", name: "Gujarat" },
  { code: "HR", name: "Haryana" },
  { code: "HP", name: "Himachal Pradesh" },
  { code: "JK", name: "Jammu and Kashmir" },
  { code: "JH", name: "Jharkhand" },
  { code: "KA", name: "Karnataka" },
  { code: "KL", name: "Kerala" },
  { code: "LA", name: "Ladakh" },
  { code: "LD", name: "Lakshadweep" },
  { code: "MP", name: "Madhya Pradesh" },
  { code: "MH", name: "Maharashtra" },
  { code: "MN", name: "Manipur" },
  { code: "ML", name: "Meghalaya" },
  { code: "MZ", name: "Mizoram" },
  { code: "NL", name: "Nagaland" },
  { code: "OD", name: "Odisha" },
  { code: "PY", name: "Puducherry" },
  { code: "PB", name: "Punjab" },
  { code: "RJ", name: "Rajasthan" },
  { code: "SK", name: "Sikkim" },
  { code: "TN", name: "Tamil Nadu" },
  { code: "TS", name: "Telangana" },
  { code: "TR", name: "Tripura" },
  { code: "UP", name: "Uttar Pradesh" },
  { code: "UK", name: "Uttarakhand" },
  { code: "WB", name: "West Bengal" },
];

export function findIndianStateByCode(
  code: string | null | undefined,
): IndianStateOption | undefined {
  if (code == null || code === "") return undefined;
  const normalized = code.trim().toUpperCase();
  return INDIAN_STATES.find((s) => s.code === normalized);
}

const STATE_NAME_ALIASES: Record<string, string> = {
  chattisgarh: "CG",
  pondicherry: "PY",
  "lakshadweep islands": "LD",
  "dadra & nagar haveli and daman & diu": "DN",
  "dadra and nagar haveli": "DN",
};

export function resolveIndianStateCode(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return "";
  const byCode = findIndianStateByCode(trimmed);
  if (byCode) return byCode.code;
  const byName = INDIAN_STATES.find(
    (s) => s.name.toLowerCase() === trimmed.toLowerCase(),
  );
  if (byName) return byName.code;
  const alias = STATE_NAME_ALIASES[trimmed.toLowerCase()];
  if (alias) return alias;
  return trimmed.toUpperCase();
}